import { Entity } from '@bingads-webui-campaign-react/constants';
import { PredicateIconClassNames } from '@bingads-webui/humanized-predicate';
import { levelAtConstant } from '@bingads-webui-campaign/scope-constants';

const getPredicateIconClassNameImpl = (entity) => {
  if (!entity || !entity.constructor || !entity.constructor.name || entity.constructor.name !== Entity.Label) {
    return null;
  }
  return entity.Scope === levelAtConstant.ACCOUNT ? PredicateIconClassNames.LabelsCellAccount : PredicateIconClassNames.LabelsCellMCC;
};

export const getPredicateIconClassName = (permissions) => {
  if (!permissions || !permissions.IsAccountLabelsEnabled) {
    return undefined;
  }

  return getPredicateIconClassNameImpl;
};
